import { render, staticRenderFns } from "./attach-document-screen.component.vue?vue&type=template&id=c5f66e2c&"
import script from "./attach-document-screen.component.vue?vue&type=script&lang=ts&"
export * from "./attach-document-screen.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports